import { useAtom } from '@reatom/npm-react'
import { useTranslation } from 'react-i18next'
import { css } from 'styled-components'

import { SegmentControl } from '@blade/ui-kit'
import { profileTabAtom } from '@root/features/user/profile-header/atoms'
import { PREMIUM_ENABLED } from '@root/shared'

import type { ProfileOwner } from '@root/features/user/profile/model/profile-owner'
import type { ProfileTab } from '@root/features/user/profile-header/atoms'

type ProfileNavigationProps = {
  profileOwner: ProfileOwner
}

export const ProfileNavigation: React.FC<ProfileNavigationProps> = () => {
  const { t } = useTranslation()
  const [tab, setTab] = useAtom(profileTabAtom)

  const handleTabChange = (tab: ProfileTab) => setTab(tab)

  return (
    <SegmentControl
      css={css`
        justify-self: center;
      `}
      value={tab}
      onChange={handleTabChange}
    >
      <SegmentControl.Item value={'stats' satisfies ProfileTab}>
        {t('profile.statistics')}
      </SegmentControl.Item>
      {/* Not enough space for referral tab, no referral tab on Figma */}
      {/* {profileOwner === ProfileOwner.CurrentUser ? (
        <Item value={'referral' satisfies ProfileTab}>{t('referral')}</Item>
      ) : undefined} */}
      {PREMIUM_ENABLED ? (
        <SegmentControl.Item value={'premium' satisfies ProfileTab}>
          {t('premium.title')}
        </SegmentControl.Item>
      ) : undefined}
      <SegmentControl.Item value={'positions-active' satisfies ProfileTab}>
        {t('position_other')}
      </SegmentControl.Item>
      <SegmentControl.Item value={'transactions' satisfies ProfileTab}>
        {t('transaction', { count: 10 })}
      </SegmentControl.Item>
    </SegmentControl>
  )
}
